import * as React from 'react';

import { classNames } from '@core/utils/functions/class-names';

type PageHeaderProps = {
    className?: string;
    title: string;
    description?: string;
};

const PageHeader = (props: PageHeaderProps) => {
    const { title, description, className } = props;

    return (
        <div
            className={classNames('flex justify-between items-center flex-grow-0 flex-shrink-0 w-full py-5', className)}
        >
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 gap-2.5">
                <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 relative">
                    <h1 className="text-5xl font-semibold text-left capitalize text-dark">{title}</h1>
                </div>
                {description && (
                    <div className="md:flex justify-start items-start flex-grow-0 flex-shrink-0 relative gap-2.5">
                        <p className="text-light-gray">{description}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PageHeader;
